import Vision from './Vision';

export default Vision;
